import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * The project defines its own font sizes as Tailwind v4 theme tokens in
 * `styles/theme.css` (`--text-theme-sm`, `--text-title-lg`, …). tailwind-merge only
 * knows the stock scale, so it reads `text-theme-sm` as a text COLOUR and lets
 * a later `text-gray-500` erase it. Registering them as font sizes keeps size
 * and colour in separate groups, the way `text-sm text-gray-500` behaves.
 *
 * Keep this list in sync with the `--text-*` tokens in `src/styles/theme.css`.
 */
const CUSTOM_FONT_SIZES = [
	"theme-xl",
	"theme-sm",
	"theme-xs",
	"title-2xl",
	"title-xl",
	"title-lg",
	"title-md",
	"title-sm",
];

const twMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			"font-size": [{ text: CUSTOM_FONT_SIZES }],
		},
	},
});

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
